import type { ChangeEvent, FC } from "react";

import { InputNumberStyle } from "../../../../documentation/styles/InputStyle";
import type { FormInputProps } from "../../types/types";

interface NumberInputProps extends FormInputProps<string> {
    readOnly: boolean;
}

export const NumberInput: FC<NumberInputProps> = ({ onChange, readOnly, ...restProps }) => {
    const onValueChange = (ev: ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange(ev.target.value);
        }
    };

    return (
        <InputNumberStyle
            type="number"
            className={readOnly ? "aevi-input aevi-input-number aevi-input-disabled" : "aevi-input aevi-input-number"}
            disabled={readOnly}
            onChange={onValueChange}
            {...restProps}
        />
    );
};
